/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import {
	PageShell,
	SectionDivider,
	SectionWrapper,
} from "./SocialInitiatives.page-primitives";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import SocialEnvironmentalInitiatives from "@/components/customCopmonent/SocialEnvironmentalInitiatives";
import Seo from "@/components/Seo";

const SocialInitiatives = () => {
	const { t } = useTranslation();

	const pageData = {
		title: t("aboutPages.socialInitiatives.hero.title"),
		description: t("aboutPages.socialInitiatives.hero.tagline"),
		meta: [
			t("aboutPages.socialInitiatives.hero.meta.sustainability"),
			t("aboutPages.socialInitiatives.hero.meta.communityImpact"),
			t("aboutPages.socialInitiatives.hero.meta.responsibility"),
		],
		bgimage: "/images/social/TreePlantationInitiative.jpg",
		initiatives: {
			title: t("aboutPages.socialInitiatives.intro.title"),
			description: t("aboutPages.socialInitiatives.intro.description"),
			sections: {
				environmental_management: {
					title: t("aboutPages.socialInitiatives.environmental.title"),
					initiatives: [
						{
							name: t(
								"aboutPages.socialInitiatives.environmental.items.treePlantation.name",
							),
							image: "/images/social/TreePlantationInitiative.jpg",
							description: t(
								"aboutPages.socialInitiatives.environmental.items.treePlantation.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.environmental.items.resourceEfficiency.name",
							),
							image: "/images/social/ResourceEfficiency.jpg",
							description: t(
								"aboutPages.socialInitiatives.environmental.items.resourceEfficiency.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.environmental.items.wasteReduction.name",
							),
							image: "/images/social/WasteReduction.jpg",
							description: t(
								"aboutPages.socialInitiatives.environmental.items.wasteReduction.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.environmental.items.sustainableSourcing.name",
							),
							image: "/images/social/SustainableSourcing.png",
							description: t(
								"aboutPages.socialInitiatives.environmental.items.sustainableSourcing.description",
							),
						},
					],
				},
				social_engagement: {
					title: t("aboutPages.socialInitiatives.social.title"),
					description: t("aboutPages.socialInitiatives.social.description"),
					initiatives: [
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.artificialLimb.name",
							),
							image: "/images/social/ArtificialLimbDonation.jpg",
							description: t(
								"aboutPages.socialInitiatives.social.items.artificialLimb.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.bloodDonation.name",
							),
							image: "/images/social/BloodDonationCamps.jpg",
							description: t(
								"aboutPages.socialInitiatives.social.items.bloodDonation.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.medicalLogistics.name",
							),
							image: "/images/social/ambulance.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.medicalLogistics.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.animalWelfare.name",
							),
							image: "/images/social/cow.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.animalWelfare.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.youthSkill.name",
							),
							image: "/images/social/school.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.youthSkill.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.educationalSupport.name",
							),
							image: "/images/social/school2.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.educationalSupport.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.culturalHeritage.name",
							),
							image: "/images/social/calture.jpg",
							description: t(
								"aboutPages.socialInitiatives.social.items.culturalHeritage.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.infrastructure.name",
							),
							image: "/images/social/infrastructure.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.infrastructure.description",
							),
						},
						{
							name: t(
								"aboutPages.socialInitiatives.social.items.disasterRelief.name",
							),
							image: "/images/social/disister.jpeg",
							description: t(
								"aboutPages.socialInitiatives.social.items.disasterRelief.description",
							),
						},
					],
				},
			},
		},
	};

	return (
		<PageShell>
			<Seo
				titleKey="aboutPages.socialInitiatives.seo.title"
				descriptionKey="aboutPages.socialInitiatives.seo.description"
				path="/social-initiatives"
			/>
			<Navigation />{" "}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SocialEnvironmentalInitiatives data={pageData.initiatives} />
			<SectionDivider />
			<FooterSection />
		</PageShell>
	);
};

export default SocialInitiatives;
